module.exports = __webpack_public_path__ + "img/激活额度 (1).d57b9973.png";